import axios from 'axios'
import { Message } from 'element-ui/lib'
/**
 * HTTP Ajax请求
 * @type {{}}
 */
function request (config = {}) {
  return axios.request(configure(config))
}
function get (url, config = {}) {
  return axios.get(url, configure(config))
}
function deleteFunc (url, config = {}) {
  return axios.delete(url, configure(config))
}
function post (url, data = {}, config = {}) {
  return axios.post(url, data, configure(config))
}
function put (url, data = {}, config = {}) {
  return axios.put(url, data, configure(config))
}

function configure (config) {
  return Object.assign({}, config, { withCredentials: true, headers: { 'token': getToken() } })
}
function getToken () {
  return localStorage.token
}

/** 如果401、未登录，尝试登陆、之前的请求重试 */
axios.interceptors.response.use(null, (error) => {
  const config = error.config
  if (config && error.response.status === 401) { // 如果是401的错误
    // Message.error('没有权限，请尝试重新登陆')
  }
  if (error.response.status >= 500) {
    Message.error('网络错误，请重试！')
  }
  return Promise.reject(error)
})

export default {
  request,
  get,
  post,
  put,
  'delete': deleteFunc,
  CancelToken: axios.CancelToken,
  getToken
}



// WEBPACK FOOTER //
// ./src/utils/http.js